export default __webpack_public_path__ + "static/media/OpenHihat.23e1e1e5.wav";